var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useMemo, useState } from 'react';
import InputMi from "./InputMi";
var InputPassword = React.forwardRef(function (props, ref) {
    var _a = useState(false), showPassword = _a[0], setShowPassword = _a[1];
    var onChangeCheckbox = function (event) {
        setShowPassword(event.target.checked);
    };
    var renduBoutonAction = useMemo(function () {
        var id = "password-show";
        if (props.id) {
            id = "password-".concat(props.id, "-show");
        }
        return (React.createElement("div", { className: "fr-password__checkbox fr-checkbox-group fr-checkbox-group--sm" },
            React.createElement("input", { "aria-label": "Afficher le mot de passe", id: id, type: "checkbox", "aria-describedby": id + "messages", onChange: onChangeCheckbox }),
            React.createElement("label", { className: "fr-password__checkbox fr-label", htmlFor: id }, "Afficher"),
            React.createElement("div", { className: "fr-messages-group", id: id + "messages", "aria-live": "assertive" })));
    }, [onChangeCheckbox, props.id]);
    return (React.createElement(InputMi, __assign({}, props, { type: showPassword ? 'text' : 'password', append: renduBoutonAction, ref: ref })));
});
export default InputPassword;
